<script setup lang="ts">
</script>

<template>
  <div border="~ base" flex="~ col" rounded-lg bg-muted p-4 class="font-sans">
    <slot />
  </div>
</template>
